var _style, _path, _g, _defs, _path2, _defs2, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBetaCaroteneDeficiency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#AA1917;}\n\t.st1{fill:#75AF54;}\n\t.st2{fill:#EF8D14;}\n\t.st3{clip-path:url(#SVGID_2_);fill:#D17611;}\n\t.st4{opacity:0;clip-path:url(#SVGID_4_);fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.7,180.3c42.8,0,77.6-34.4,77.6-76.9c0-42.4-34.7-76.9-77.6-76.9S28.2,61,28.2,103.4 C28.2,145.8,62.9,180.3,105.7,180.3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141.4,80.2c8.7-5.2,10.8-20.4,9.1-18.6c1.7-1.7-13.8,0-19,8.7c0-3.5-3.5-17.3-8.7-5.2 c-5.2,12.1-3.5,13.8-3.5,17.3c0,3.5,6.9,3.5,6.9,3.5s-0.3,6.6,3.2,6.6c3.5,0,4.9,1.4,17-3.8C158.5,83.5,144.9,80.2,141.4,80.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M120.2,116.1c-18.6,18.6-49.3,32-53.7,27.7s9.1-35,27.7-53.7c18.6-18.6,28.2-18.5,36.3-10.4 C138.7,87.9,138.8,97.5,120.2,116.1"
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M94.2,90.2c-18.6,18.6-32,49.3-27.7,53.7c4.3,4.3,35-9,53.7-27.7c18.6-18.6,18.5-28.2,10.4-36.3 c-3.3-3.3-6.7-5.2-10.9-5.2C113.3,74.6,105.4,79,94.2,90.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M105,134.5c-11.2-5.6-16.8-11.2-19.6-14c-2.8-2.8,2.8,14,14,19.6C110.6,145.7,105,134.5,105,134.5 M127,114.9 c-11.2-5.6-16.8-11.2-19.6-14c-2.8-2.8,2.8,14,14,19.6C132.6,126.1,127,114.9,127,114.9 M86.5,94.1c5.6,11.2,11.2,16.8,14,19.6 c2.8,2.8-14-2.8-19.6-14C75.3,88.5,86.5,94.1,86.5,94.1 M104.8,74.4c5.6,11.2,11.2,16.8,14,19.6c2.8,2.8-14-2.8-19.6-14 C93.6,68.8,104.8,74.4,104.8,74.4"
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M105.7,180.3c42.8,0,77.6-34.4,77.6-76.9c0-42.4-34.7-76.9-77.6-76.9S28.2,61,28.2,103.4 C28.2,145.8,62.9,180.3,105.7,180.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "28.2,107.7 183.3,107.7 192.6,154.3 151.7,191.3 105.7,200.6 22.8,190.3 22.8,124.4  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetaCaroteneDeficiency);
export default __webpack_public_path__ + "static/media/Beta_Carotene_Deficiency.9ad9dc7a90735a49175f50d93437a4aa.svg";
export { ForwardRef as ReactComponent };